Vue.component('guestflip-goals', {

  props: ['team'],

  computed: {
    teamId() {
      return this.team ? this.team.id : Spark.state.currentTeam.id
    },
    selectedGoal() {
      return this.goals ? this.goals[this.selectedIndex] : null
    },
    noGoals() {
      return this.goals != null && this.goals.length == 0
    }
  },

  data() {
    return {
      expandAddGoal: false,
      goals: null,
      selectedIndex: 0,
      goalBreakdown: null,
      showCanceled: false
    }
  },


  methods: {
    toggleAddGoal () {
      if (! this.expandAddGoal) {
        analytics.track("Clicked Add Goal", {
          team_id: this.teamId
        })
      }
      this.expandAddGoal = ! this.expandAddGoal
    },
    fetchGoals() {
      axios.get('/api/goals/' + this.teamId + '?showCancelled=' + this.showCanceled)
      .then(response => {

        this.goals = response.data
        this.getGoalBreakdown()

      })
    },
    getGoalBreakdown() {
      
      let goal = this.goals[this.selectedIndex]

      if (! goal) {
        return
      }

      axios.get('/api/goals/' + this.teamId + '/' + goal.id + '/breakdown')
      .then(response => {
        this.goalBreakdown = response.data
      })

    },
    selectGoal(index) {

      this.selectedIndex = index
      this.getGoalBreakdown()

    },
    toggleGoalAction(params) {
      
      let action = params.action
      let source = params.source_name

      if (action == 'new') {
        this.expandAddGoal = true
        this.$eventHub.$emit('setAddGoalSelectedSource', source)
        return
      }

      // enable first occurence of source
      for (goal in this.goals) {
        if (this.goals[goal].source == source && this.goals[goal].is_active) {
          this.selectedIndex = goal
          return
        }
      }

    }
  },

  mounted() {

    this.$on('closeAddGoal', val => this.expandAddGoal = false)
    this.$on('selectGoal', index => this.selectGoal(index))

    this.$eventHub.$on('goalsUpdated', value => this.fetchGoals())
    this.$eventHub.$on('toggleGoalAction', action => this.toggleGoalAction(action))

    this.fetchGoals()

  }

})